import { render, staticRenderFns } from "./RoleDetailUpload.vue?vue&type=template&id=71507b3d&"
import script from "./RoleDetailUpload.vue?vue&type=script&lang=js&"
export * from "./RoleDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports